import { log } from "../../utils/log.ts";
import { overrideFetch } from "./interceptors/fetch";
import { overrideXHR } from "./interceptors/xhr";
import { refreshTokenIfNeeded } from "./tokenManager";

export const initAuthCore = () => {
    log('AuthCore initialized');
    overrideFetch();
    overrideXHR();

    refreshTokenIfNeeded();
}

